import classNames from "classnames";
import scss from "@/styles/pages/webinars/webinar-content.module.scss";

export const wrapper = classNames(
  // Mobile
  "mobile:m-12",
  "mobile:py-8",
  "mobile:px-8",
  // Tablet
  "tablet:my-12",
  "tablet:mx-24",
  // All
  "flex",
  "flex-row",
  "items-start",
  "justify-start",
  "border solid",
  "border-opacity-30",
  "rounded-xl shadow-2xl",
  "shadow-gray-400"
);
export const contentContainer = classNames(
  // Mobile
  "mobile:flex-col",
  // Tablet
  "tablet:flex-row",
  // All
  "flex",
  "items-start",
  "justify-start",
  "text-gray-600"
);
export const image = classNames(
  // Mobile
  "mobile:items-center",
  "mobile:w-fit",
  // Tablet
  "tablet:items-start",
  "tablet:w-1/4",
  // All
  "w-full",
  "h-full",
  scss["youTubeIcon"]
);
export const content = classNames(
  // Mobile
  "mobile:w-fit",
  // Tablet
  "tablet:px-8",
  "tablet:w-4/5"
  // All
);
export const title = classNames(
  // Mobile
  "mobile:pt-8",
  // Tablet
  "tablet:pt-0",
  // All
  "text-2xl",

  "font-bold"
);
export const subtext = classNames(
  // Mobile
  // Tablet
  // All
  "text-md",
  "font-normal",
  "pt-1"
);
export const text = classNames(
  // Mobile
  // Tablet
  // All
  "pt-4",
  "text-xl",
  "font-normal"
);
